import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Flex,
  Heading,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import { useMemo, useState, useEffect } from "react";
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import CountUpComponent from "common/components/countUpComponent";
import Pagination from "common/components/pagination/Pagination";
import { AddIcon } from "@chakra-ui/icons";
import DataNotFound from "common/components/notFoundData";
import DateFormatter from "common/utils/dateFormater";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import AddEmailHistory from "services/Crm/components/emailHistory/AddEmail";
import "common/assets/css/viewEdit.css";
import { globalStyles } from "common/theme/styles";
import { crmConstant } from "services/Crm/constant";
import { constant } from "common/constant";
import useGlobalTable from "services/Crm/utils/tableInstance";

export default function ColumnsTable(props) {
  const {
    columnsData,
    tableData,
    setAction,
    title,
    fetchData,
    addTitle,
    setIsShowDynamicModel,
    modalType,
    emailAccess,
    allData,
    isLead,
    initialValues,
    lead,
    dynamic = false,
  } = props;
  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);
  const navigate = useNavigate();
  const param = useParams();
  const [addEmailHistory, setAddEmailHistory] = useState(false);
  const [gopageValue, setGopageValue] = useState();
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    pageIndex,
    pageSize,
  } = useGlobalTable(columns, data);

  const textColor = useColorModeValue("gray.500", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const buttonbg = useColorModeValue("gray.200", "white");

  useEffect(() => {
    if (gopageValue === undefined && pageOptions.length < gopageValue) {
      setGopageValue(pageOptions.length);
    }
  }, [pageOptions, gopageValue]);

     useEffect(() => {
    document.body.classList.add("bgWhiteImp");
    return () => {
      document.body.classList.remove("bgWhiteImp");
    };
  }, []);

  return (
    <>
      <Box className="viewEditAccordian">
        <Box className="viewEditAccordianItem">
          <Box className="viewEditAccordianBtn">
            <Flex justify="space-between" w="full" align="center">
              <Flex gap={"20px"} alignItems={"center"}>
                <Heading className="viewEditAccordianHeader" size="md">
                  {title}
                  {/* (
                  <CountUpComponent
                    key={isLead ? allData?.Email?.length : allDatia?.EmailHistory?.length}
                    targetNumber={isLead ? allData?.Email?.length : allData?.EmailHistory?.length}
                  />
                  ) */}
                </Heading>
                {/* <AccordionIcon color={globalStyles.colors.iconDark} /> */}
              </Flex>

              {emailAccess?.create &&
                (title === "Account" ? tableData.length === 0 : true) && (
                  <Button
                    size="sm"
                    // onClick={(event) => {
                    //   event.stopPropagation();
                    //   setAddEmailHistory(true);
                    // }}
                    onClick={() => {
                      if (modalType) {
                        // Handle modal open based on title
                        setIsShowDynamicModel({
                          type:
                            title === crmConstant.accounts
                              ? crmConstant.accounts
                              : title === crmConstant.contacts
                              ? crmConstant.contacts
                              : crmConstant.deals,
                          isShow: true,
                        });
                      } else {
                        // Navigate to create pages
                        if (title === "Deals") {
                          navigate("/crm/Deals/create");
                        } else if (title === "Account") {
                          navigate("/crm/Accounts/create");
                        } else {
                          navigate("/crm/email/createEmail", {
                            state: {
                              initialValuesProp: initialValues,
                              view: lead
                                ? constant.lead
                                : dynamic
                                ? initialValues?.dealName
                                  ? constant.deals
                                  : constant.accounts
                                : constant.contact,
                            },
                          });
                        }
                      }
                    }}
                    leftIcon={
                      <AddIcon
                        fontSize={"12px"}
                        color={globalStyles.colors.iconDark}
                      />
                    }
                    className="accordianAddBtn"
                  >
                    {addTitle ? addTitle : constant.addNew}
                  </Button>
                )}
            </Flex>
          </Box>
          <Box className="viewEditAccordianPannel" pb={4}>
            <Box overflowY="auto" className="table-container p0">
              <Table
                {...getTableProps()}
                variant="simple"
                color="gray.500"
                className="lead-table-main"
              >
                <Thead className="viewEditAccordian-tableHead">
                  {headerGroups?.map((headerGroup, index) => (
                    <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                      {headerGroup.headers.map((column, index) => (
                        <Th
                          {...column.getHeaderProps(
                            column.isSortable !== false &&
                              column.getSortByToggleProps()
                          )}
                          key={index}
                          borderColor={borderColor}
                        >
                          <Text>{column.render("Header")}</Text>
                        </Th>
                      ))}
                    </Tr>
                  ))}
                </Thead>
                <Tbody {...getTableBodyProps()}>
                  {data?.length === 0 ? (
                    <Tr>
                      <Td colSpan={columns?.length} textAlign="center" className="nodataTd">
                        <DataNotFound title={title} />
                      </Td>
                    </Tr>
                  ) : (
                    page?.map((row, index) => {
                      prepareRow(row);
                      return (
                        <Tr
                          {...row.getRowProps()}
                          key={index}
                          cursor="pointer"
                          onClick={() => {
                            if (title === "Deals") {
                              navigate(`/crm/Deals/${row.original?._id}`, {
                                state: {
                                  module: props.moduleData,
                                  isEdit: true,
                                },
                              });
                            } else if (title === "Accounts") {
                              navigate(`/crm/Accounts/${row.original?._id}`, {
                                state: {
                                  module: props.moduleData,
                                  isEdit: true,
                                },
                              });
                            } else if (title === "Contacts") {
                              navigate(
                                `/crm/contacts/contactView/${row.original?._id}`,
                                {
                                  state: {
                                    module: props.moduleData,
                                    isEdit: true,
                                  },
                                }
                              );
                            } else {
                              navigate(`/crm/email`);
                            }
                          }}
                        >
                          {row.cells.map((cell, index) => (
                            <Td
                              key={index}
                              {...cell.getCellProps()}
                              fontSize={{ sm: "14px" }}
                              borderColor="transparent"
                            >
                              {cell.column.Header === crmConstant.sender ? (
                                <Flex align="center">
                                  <Text fontSize="sm" fontWeight="700">
                                    {cell.value}
                                  </Text>
                                </Flex>
                              ) : cell.column.Header ===
                                crmConstant.recipient ? (
                                <Flex align="center">
                                  <Text fontSize="sm" fontWeight="700">
                                    {cell.value}
                                  </Text>
                                </Flex>
                              ) : cell.column.Header ===
                                crmConstant.createdAt ? (
                                <Text>
                                  {DateFormatter(cell.row.values.timestamp)}
                                </Text>
                              ) : cell.column.Header ===
                                crmConstant.timeStamp ? (
                                <Text>{moment(cell.value).fromNow()}</Text>
                              ) : (
                                cell.render("Cell")
                              )}
                            </Td>
                          ))}
                        </Tr>
                      );
                    })
                  )}
                </Tbody>
              </Table>
            </Box>
            {data?.length > 5 && (
              <Pagination
                gotoPage={gotoPage}
                gopageValue={gopageValue}
                setGopageValue={setGopageValue}
                pageCount={pageCount}
                canPreviousPage={canPreviousPage}
                previousPage={previousPage}
                canNextPage={canNextPage}
                pageOptions={pageOptions}
                setPageSize={setPageSize}
                nextPage={nextPage}
                pageSize={pageSize}
                pageIndex={pageIndex}
                dataLength={data?.length}
              />
            )}
          </Box>
        </Box>
      </Box>
      <AddEmailHistory
        lead={props.lead}
        leadEmail={props?.viewData?.lead?.leadEmail}
        contactEmail={props?.viewData?.contact?.email}
        fetchData={fetchData}
        isOpen={addEmailHistory}
        setAction={setAction}
        onClose={setAddEmailHistory}
        id={param.id}
      />
    </>
  );
}
